import { type ReactElement } from 'react';
import { Chip } from '@/components/atoms/chip';
import { CONTRIBUTE_FORM_OPTIONS, type ContributeFormOption } from '@/lib/contribute-form';

export type ContributeFormSectionProps = {
  selected: ContributeFormOption[];
  onToggle: (form: ContributeFormOption) => void;
};

export function ContributeFormSection({
  selected,
  onToggle,
}: ContributeFormSectionProps): ReactElement {
  return (
    <div role="group" aria-label="Form" className="flex flex-wrap gap-1.5">
      {CONTRIBUTE_FORM_OPTIONS.map((form) => {
        const isSelected = selected.includes(form);
        return (
          <Chip
            key={form}
            active={isSelected}
            aria-pressed={isSelected}
            onClick={() => onToggle(form)}
          >
            {form}
          </Chip>
        );
      })}
    </div>
  );
}
